import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/sl/501/',
    component: ComponentCreator('/sl/501/', '378'),
    exact: true
  },
  {
    path: '/sl/articles/',
    component: ComponentCreator('/sl/articles/', '88b'),
    exact: true
  },
  {
    path: '/sl/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/sl/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'e4b'),
    exact: true
  },
  {
    path: '/sl/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/sl/articles/2024/07/09/diskusija-lj-nj/', '7ed'),
    exact: true
  },
  {
    path: '/sl/articles/archive/',
    component: ComponentCreator('/sl/articles/archive/', '62c'),
    exact: true
  },
  {
    path: '/sl/articles/authors/',
    component: ComponentCreator('/sl/articles/authors/', 'ac1'),
    exact: true
  },
  {
    path: '/sl/search/',
    component: ComponentCreator('/sl/search/', '29a'),
    exact: true
  },
  {
    path: '/sl/',
    component: ComponentCreator('/sl/', 'b9f'),
    exact: true
  },
  {
    path: '/sl/',
    component: ComponentCreator('/sl/', '6da'),
    routes: [
      {
        path: '/sl/',
        component: ComponentCreator('/sl/', '774'),
        routes: [
          {
            path: '/sl/tags/',
            component: ComponentCreator('/sl/tags/', 'a62'),
            exact: true
          },
          {
            path: '/sl/tags/comparative/',
            component: ComponentCreator('/sl/tags/comparative/', '0d2'),
            exact: true
          },
          {
            path: '/sl/tags/grammar/',
            component: ComponentCreator('/sl/tags/grammar/', 'dcd'),
            exact: true
          },
          {
            path: '/sl/tags/interslavic/',
            component: ComponentCreator('/sl/tags/interslavic/', '495'),
            exact: true
          },
          {
            path: '/sl/tags/language-learning/',
            component: ComponentCreator('/sl/tags/language-learning/', 'c48'),
            exact: true
          },
          {
            path: '/sl/tags/linguistics/',
            component: ComponentCreator('/sl/tags/linguistics/', '332'),
            exact: true
          },
          {
            path: '/sl/tags/medoslovanski-jezik/',
            component: ComponentCreator('/sl/tags/medoslovanski-jezik/', '2fb'),
            exact: true
          },
          {
            path: '/sl/tags/medslovansko/',
            component: ComponentCreator('/sl/tags/medslovansko/', 'b68'),
            exact: true
          },
          {
            path: '/sl/tags/personal-pronouns/',
            component: ComponentCreator('/sl/tags/personal-pronouns/', '466'),
            exact: true
          },
          {
            path: '/sl/tags/primerjava-jezikov/',
            component: ComponentCreator('/sl/tags/primerjava-jezikov/', 'f8e'),
            exact: true
          },
          {
            path: '/sl/tags/pronouns/',
            component: ComponentCreator('/sl/tags/pronouns/', 'bf9'),
            exact: true
          },
          {
            path: '/sl/tags/slavic-languages/',
            component: ComponentCreator('/sl/tags/slavic-languages/', 'c15'),
            exact: true
          },
          {
            path: '/sl/tags/slovnica/',
            component: ComponentCreator('/sl/tags/slovnica/', '3dd'),
            exact: true
          },
          {
            path: '/sl/tags/ucenje-jezika/',
            component: ComponentCreator('/sl/tags/ucenje-jezika/', '361'),
            exact: true
          },
          {
            path: '/sl/tags/zaimki/',
            component: ComponentCreator('/sl/tags/zaimki/', '083'),
            exact: true
          },
          {
            path: '/sl/',
            component: ComponentCreator('/sl/', '098'),
            routes: [
              {
                path: '/sl/learn/faq/',
                component: ComponentCreator('/sl/learn/faq/', '558'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/',
                component: ComponentCreator('/sl/learn/grammar/', '86d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/adjectives/',
                component: ComponentCreator('/sl/learn/grammar/adjectives/', 'f15'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/conjunctions/',
                component: ComponentCreator('/sl/learn/grammar/conjunctions/', 'c11'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/nouns/',
                component: ComponentCreator('/sl/learn/grammar/nouns/', '686'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/numerals/',
                component: ComponentCreator('/sl/learn/grammar/numerals/', '5fc'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/prepositions/',
                component: ComponentCreator('/sl/learn/grammar/prepositions/', '145'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/pronouns/',
                component: ComponentCreator('/sl/learn/grammar/pronouns/', 'd39'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/syntax/',
                component: ComponentCreator('/sl/learn/grammar/syntax/', 'ae7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/grammar/verbs/',
                component: ComponentCreator('/sl/learn/grammar/verbs/', '09e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/introduction/',
                component: ComponentCreator('/sl/learn/introduction/', 'd0f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/sl/learn/misc/constructed-slavic-languages/', 'b9a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/design-criteria/',
                component: ComponentCreator('/sl/learn/misc/design-criteria/', '34c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/history/',
                component: ComponentCreator('/sl/learn/misc/history/', 'c8c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/language-comparison/',
                component: ComponentCreator('/sl/learn/misc/language-comparison/', '919'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/numbers-1-10/',
                component: ComponentCreator('/sl/learn/misc/numbers-1-10/', '4d6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/sl/learn/misc/pan-slavic-relay/', 'ac0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/misc/personal-pronouns/',
                component: ComponentCreator('/sl/learn/misc/personal-pronouns/', '844'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/orthography/',
                component: ComponentCreator('/sl/learn/orthography/', 'd66'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/phonology/',
                component: ComponentCreator('/sl/learn/phonology/', '3c2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/pronunciation/',
                component: ComponentCreator('/sl/learn/pronunciation/', '2bd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/simple-grammar/',
                component: ComponentCreator('/sl/learn/simple-grammar/', 'f8a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/simple-grammar/level-1/',
                component: ComponentCreator('/sl/learn/simple-grammar/level-1/', '86b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/simple-grammar/level-2/',
                component: ComponentCreator('/sl/learn/simple-grammar/level-2/', 'ae7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/vocabulary/derivation/',
                component: ComponentCreator('/sl/learn/vocabulary/derivation/', '028'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/sl/learn/vocabulary/flavourisation/', '91d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/learn/vocabulary/word-formation/',
                component: ComponentCreator('/sl/learn/vocabulary/word-formation/', '84d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sl/resources/',
                component: ComponentCreator('/sl/resources/', '8d4'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sl/resources/applets/',
                component: ComponentCreator('/sl/resources/applets/', 'f15'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sl/resources/applets/intelligibility/',
                component: ComponentCreator('/sl/resources/applets/intelligibility/', '035'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sl/resources/applets/transliterator/',
                component: ComponentCreator('/sl/resources/applets/transliterator/', '71a'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sl/resources/keyboards/',
                component: ComponentCreator('/sl/resources/keyboards/', '3e9'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
